import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserSubscriptionStatus } from "@/services/billingService";

// Async thunk: fetch subscription status from billing API
export const fetchSubscriptionStatus = createAsyncThunk(
    "subscription/fetchStatus",
    async (_, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            var lastFetched = state.Subscription?.lastFetched || 0;

            // Dedup: skip if last fetch was < 60s ago
            if (Date.now() - lastFetched < 60000) {
                return rejectWithValue("THROTTLED");
            }

            var daysRemaining = await getUserSubscriptionStatus();
            return { daysRemaining: daysRemaining };
        } catch (err) {
            return rejectWithValue(err?.message || "Failed to fetch subscription status");
        }
    }
);

var initialState = {
    canPlay: false,
    daysRemaining: 0,
    loading: true,
    lastFetched: 0,
    subscriptionInfo: null,
    error: null,
};

var subscriptionSlice = createSlice({
    name: "subscription",
    initialState: initialState,
    reducers: {
        clearSubscription: function (state) {
            state.canPlay = false;
            state.daysRemaining = 0;
            state.loading = false;
            state.lastFetched = 0;
            state.subscriptionInfo = null;
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(fetchSubscriptionStatus.pending, function (state) {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSubscriptionStatus.fulfilled, function (state, action) {
                var days = action.payload.daysRemaining;
                state.daysRemaining = days;
                state.canPlay = days > 0;
                state.loading = false;
                state.lastFetched = Date.now();
                state.error = null;
            })
            .addCase(fetchSubscriptionStatus.rejected, function (state, action) {
                // Don't mark as error if just throttled
                if (action.payload === "THROTTLED") {
                    state.loading = false;
                    return;
                }
                state.loading = false;
                state.error = action.payload || "Unknown error";
            });
    },
});

export var clearSubscription = subscriptionSlice.actions.clearSubscription;
export default subscriptionSlice.reducer;
